import React from "react";
import { CredentialingSubmitContext } from "../providers/credentialingSubmit";

export default function useCredentialSubmit() {
  return React.useContext(CredentialingSubmitContext);
}